import m from "../../../../geodata/es2015/region/usa/maHigh";
window.am4geodata_region_usa_maHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/maHigh.js
// module id = null
// module chunks = 